import { createStore } from '@aibees/shared/store';
import { ViewRecordsPopoverStoreData as StoreData } from './types';

const useViewRecordsPopoverStore = createStore<StoreData>(
  'view-records-popover',
  (set) => ({
    open: null,
    visiblity: true,
    loading: false,
    visible: false,
    compact: false,
    setVisible: (visible) => set({ visible }),
    onOpen: (element) => {
      if (element) set({ open: element });
    },
    onClose: () => set({ open: null, loading: false }),
    toggleVisiblity: () =>
      set((state) => {
        state.visiblity = !state.visiblity;
      }),
    showLoading: () => set({ loading: true }),
    hideLoading: () => set({ loading: false }),
    setCompact: (compact) => set({ compact }),
  })
);

export default useViewRecordsPopoverStore;
